module.exports = __webpack_public_path__ + "static/PatrickOlsen-a19ea544c16919ecd85cb30c11895d1a.jpg";